import React from 'react';

import { Drawer } from '~/components/blocks';
import { BookedButtons } from '~/components/pages/Reception/CheckinEntryProfileDrawer/Footer/BookedButtons';
import { CheckinEntryDetailFragment } from '~/graphql/generated/graphql';
import { usePlanFeature } from '~/hooks/use-plan-feature';

type Props = {
  checkinEntry?: CheckinEntryDetailFragment;
};

export const Footer = React.memo((props: Props) => {
  const { checkinEntry } = props;
  const { hasEnabledFeature: hasEnabledFollowup } = usePlanFeature('followup');
  const status = checkinEntry?.status;
  const isFinished = status === 'finished';

  if (!checkinEntry || (isFinished && !hasEnabledFollowup)) {
    return null;
  }

  if (isFinished) return null;

  return (
    <Drawer.Footer>{!isFinished && <BookedButtons checkinEntry={checkinEntry} />}</Drawer.Footer>
  );
});

Footer.displayName = 'Footer';
